<template>
  <v-card>
    <v-toolbar flat>
      <v-toolbar-title class="page-title"> {{ chartTitle }} </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-divider></v-divider>
    <div class="d-flex justify-center pa-5">
      <apexchart
        type="pie"
        :width="chartWidth"
        :series="chartSeries"
        :options="chartOptions"
      ></apexchart>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "PieChart",
  data() {
    return {};
  },
  props: {
    chartTitle: {
      type: String,
    },
    chartWidth: {
      type: Number,
    },
    chartOptions: {
      type: Object,
    },
    chartSeries: {
      type: Array,
    },
  },
};
</script>
